import { styled } from '@mui/material';

import { ButtonsContainer, Divider } from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';

import { GoogleSignInButton } from '../GoogleSignInButton';
import { FigmaSignInButton } from '../FigmaSignInButton';

const DividerContainer = styled('div')({
  padding: '0 30%',
  width: '100%',
  boxSizing: 'border-box',
});

export const AuthOptions = () => {
  const { t } = useI18n();

  return (
    <>
      <DividerContainer>
        <Divider text={t('users:auth.or_sign_in_via')} textAlign="center" />
      </DividerContainer>
      <ButtonsContainer fullWidth>
        <FigmaSignInButton />
        <GoogleSignInButton />
      </ButtonsContainer>
    </>
  );
};
